import { connect } from 'react-redux';
import _get from 'lodash/get';
import { callSelectors, conferenceSelectors, currentUserSelectors } from '@lifesize/nucleus';
import CallDetails from 'components/InCall/CallDetails';
import { openInCallDrawer, closeInCallDrawer } from 'actions/InCall/InCallDrawer';
import { getInviteForExtension, getInviteMailLinkForExtension } from 'actions/Invite';

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  let remoteContact = activeCall.remoteContact;
  if (remoteContact && typeof remoteContact !== 'string') {
    remoteContact.moderator =
      (
        !remoteContact.moderator &&
        (currentUserSelectors.myInfo(state).id === remoteContact.moderatorID)
      ) ?
        currentUserSelectors.myInfo(state) :
        remoteContact.moderator;
  } else {
    remoteContact = currentUserSelectors.myInfo(state);
  }

  const isLockedByModerator = conferenceSelectors.selectIsLocked(state) && !activeCall.isModerator;

  return {
    contact: remoteContact,
    isGuest: _get(currentUserSelectors.myInfo(state), 'isGuest'),
    isLockedByModerator
  };
};

const mapDispatchToProps = dispatch => ({
  onOpenDrawer: drawer => dispatch(openInCallDrawer(drawer)),
  closeInCallDrawer,
  getInviteForExtension: async extension => dispatch(getInviteForExtension(extension)),
  getInviteMailLinkForExtension: async extension => dispatch(getInviteMailLinkForExtension(extension))
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const extension = _get(stateProps, 'contact.dialString');
  return (
    {
      ...ownProps,
      ...stateProps,
      ...dispatchProps,
      getInviteForExtension: async () => dispatchProps.getInviteForExtension(extension),
      getInviteMailLinkForExtension: async () => dispatchProps.getInviteMailLinkForExtension(extension)
    }
  );
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CallDetails);
